import { FeatureLike } from "ol/Feature";
import { DataProps, get, Legend, getColor, getCategory } from "./state";
import { fromNullable, Option } from "./option";
import type { DataContext } from "./index";
import { Circle, Fill, Stroke, Style } from "ol/style";

const defaultSize = 5;
const selectSize = defaultSize + 2;

const selectColor = "yellow";

const point = (size: number, strokeColor: string, fillColor: string) =>
  new Style({
    image: new Circle({
      radius: size,
      fill: new Fill({ color: fillColor }),
      stroke: new Stroke({
        color: strokeColor,
        width: size / 5,
      }),
    }),
  });

const pointMultipleValuesStyle = (
  props: Option<DataProps>,
  categories: string[],
  legend: Legend,
  selected = false,
) => {
  const nonSelectedSize = props.chain(p=> fromNullable(p['size']).map(struct_size=> {
    switch(struct_size){
      case "big": return defaultSize*1.8;
      case "medium": return defaultSize*1.4;
      case "small": return defaultSize;
    }
  })).getOrElse(defaultSize)
  const size = selected ? selectSize : nonSelectedSize;
  const typeName = props
    .chain((p) => fromNullable(p[legend]).map((cp) => cp.toString()))
    .getOrElse("");
  

  const cat = fromNullable(categories.find((c) => typeName.startsWith(c)));
  const index = cat.map((c) => categories.indexOf(c)).getOrElse(-1);
  const color = selected ? selectColor : getColor(index);
  const strokeColor = selected ? "black" : color;

  return point(size, strokeColor, color);
};

export const vectorStyle =
  (key: Legend, dataContext: DataContext, selected = false) =>
  (f: FeatureLike) => {
    const categories = getCategory(key);
    const props: Option<DataProps> = dataContext.getProps(f);
    return pointMultipleValuesStyle(props, categories, key, selected);
  };

export const makeStyle = (dataContext: DataContext) => (f: FeatureLike) => {
  const s = vectorStyle(get("legend"), dataContext);
  return s(f);
};

export const makeSelectStyle =
  (dataContext: DataContext) => (f: FeatureLike) => {
    const s = vectorStyle(get("legend"), dataContext, true);
    return s(f);
  };

